module.exports = __webpack_public_path__ + "static/media/buttonsounds08.15a76de1.wav";